import { DurationFilterOptions } from '@griply/types';

import { isNumber } from './is-number';

export const isDurationFilterActive = (
  filter: DurationFilterOptions,
): boolean =>
  isNumber(filter.minDuration) ||
  isNumber(filter.maxDuration) ||
  !!filter.noDuration ||
  !!filter.hasDuration;

export const matchesDurationFilter = (
  duration: number | null | undefined,
  filter: DurationFilterOptions,
): boolean => {
  if (
    isNumber(filter.minDuration) &&
    (!duration || duration < filter.minDuration)
  ) {
    return false;
  }
  if (
    isNumber(filter.maxDuration) &&
    (!duration || duration > filter.maxDuration)
  ) {
    return false;
  }
  if (filter.noDuration && duration) {
    return false;
  }
  if (filter.hasDuration && !duration) {
    return false;
  }
  return true;
};

// An occurrence passes when it matches the duration constraint of ANY filter set
// (OR semantics), or when no filter set carries a duration constraint.
export const someFilterMatchesDuration = (
  duration: number | null | undefined,
  filters: DurationFilterOptions[] | null | undefined,
): boolean =>
  !filters?.length ||
  filters.some((filter) => matchesDurationFilter(duration, filter));
